"use client";

import { useEffect, useState } from "react";

/** Hidden by default so Careers never flashes in nav before we know there is a posting. */
export function useHasOpenJobs(): boolean {
  const [hasOpen, setHasOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch("/api/jobs?exists=1", { cache: "no-store" })
      .then((res) => (res.ok ? res.json() : { hasOpen: false }))
      .then((data) => {
        if (!cancelled && data.hasOpen) setHasOpen(true);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return hasOpen;
}
